export default "__VITE_ASSET__04e82482__"